/**
 * @generated SignedSource<<7c1c5493ed12e837c0a86de23b59e22c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetLabelContent$data = {
  readonly __typename: "Article";
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null> | null;
  } | null> | null;
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "helpersGetLabelContent";
} | {
  readonly __typename: "Gallery";
  readonly __typename: "Gallery";
  readonly " $fragmentType": "helpersGetLabelContent";
} | {
  readonly __typename: "Video";
  readonly __typename: "Video";
  readonly " $fragmentType": "helpersGetLabelContent";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "helpersGetLabelContent";
};
export type helpersGetLabelContent$key = {
  readonly " $data"?: helpersGetLabelContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetLabelContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetLabelContent"
};

(node as any).hash = "f3cbf6d620a48012f277bc0493ead1b6";

export default node;
